import * as React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";

function Quote({ who, quote }) {
  return (
    <figure className="quoteCard">
      <blockquote>
        <p>{quote}</p>
      </blockquote>
      <figcaption>{who}</figcaption>
    </figure>
  );
}

function Blog() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Blog</h2>

          <p className="pageLead">
            What&rsquo;s happening at New Harmony Therapeutic Massage and
            Somatic Bodywork.
          </p>

          {/* Post: Conscious Anatomy */}
          <article className="productCard">
            <h3 className="profileName">
              Conscious Anatomy™ Bones, Planes and Directions
            </h3>
            <p className="profileCred">Ann Watkins</p>
            <p>
              <em>
                I envision a world where the benefits of Conscious Anatomy™ are
                universally applied to bring about greater harmony to the whole
                world one person or group at a time.
              </em>
            </p>
            <p>
              Discover how to move with ease in your body. Dissolve issues in
              your tissues by bringing the unconscious conscious. Resolve long
              standing pain and discomfort and connect deeply to yourself
              through the surprising impact of learning anatomy from the inside
              out without really trying. Experience what your body has to tell
              you as you experience moving the way your body wants and needs to
              move.
            </p>
            <h5 className="subTitle">Who is Conscious Anatomy™ for?</h5>
            <p>Manual and movement therapists, and you if you want to:</p>
            <ul className="featureList">
              <li>
                Increase your energy, health, vitality, inner calm and balance
              </li>
              <li>
                Process grief, anxiety, depression, aches and pains and uplift
                your spirits
              </li>
              <li>
                Cultivate tools to deeply listen to your body without getting in
                your own way
              </li>
              <li>
                Engage in blissful, calming movement flows that allow you to
                customize to your body and optimize your healing
              </li>
              <li>
                Experience anatomy from the inside out with the added benefit of
                absorbing anatomy without really trying
              </li>
              <li>Feel refreshed, calm, enlightened and present</li>
            </ul>

            <h5 className="subTitle">What students say</h5>
            <div className="quoteGrid">
              <Quote
                who="Carol Breslin, Support Manager for the Developmentally Disabled"
                quote="Conscious Anatomy™ classes with Ann Watkins are excellent. Whether I am using a signature flow for a brief refresher or participating in a full class I always feel rejuvenated, more flexible, and ready for my day."
              />
              <Quote
                who="Rosa Peurillo, Yoga Teacher and Herbalist"
                quote="Conscious Anatomy™ has kept me balanced, in tune and energized when I've been down and low energy."
              />
              <Quote
                who="Sarah Pantalone, Spanish Teacher and Massage Therapist"
                quote="I came for the anatomy, I stayed for the somatic awareness and energetic attunement."
              />
              <Quote
                who="Susan Christini, Math Teacher and Entrepreneur"
                quote="My friend died and Conscious Anatomy™ really helped me get through that. If you're on the fence, I say take it; it is so much more than you think. You won't be disappointed."
              />
              <Quote
                who="Abby Valetta, Life Coach, Yoga Teacher and Massage Therapist"
                quote="The movement is so gentle, I am always amazed at how great I feel after class. And the anatomy just soaked in; it was really just an added benefit, a side effect if you will. This course is well worth it."
              />
            </div>

            <div className="btnRow">
              <a
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                <Button>More at bodymindspiritanatomy.com ››</Button>
              </a>
              <Link to="/classes">
                <Button variant="outline-primary">Class Details ››</Button>
              </Link>
            </div>
          </article>

          {/* Post: Online training */}
          <article className="productCard">
            <h3 className="profileName">
              Online Training: Conscious Anatomy™ Level 1, Bones, Planes and
              Directions
            </h3>
            <p className="profileCred">Events</p>
            <p>
              Conscious Anatomy™ brings 8 live, easy on the body movement
              classes that decrease pain, increase range of motion, decrease
              anxiety and increase calm energy, in the comfort of your own home
              over Zoom. You will need two snow angels worth of floor space and
              comfortable clothes.
            </p>
            <h5 className="subTitle">Level One Training</h5>
            <ul className="featureList">
              <li>
                Ease into your body with blissful movement flows designed for
                you to increase range of motion, decrease and eliminate pain,
                increase your energy, decrease anxiety, discover joie de vivre
                and absorb the anatomy without really trying.
              </li>
              <li>
                Especially for all of my private practice clients (learn what
                you can do on your own to support what we do on the table) and
                manual and movement therapists.
              </li>
              <li>
                For specific class titles and a description of each class go to
                bodymindspiritanatomy.com and scroll down.
              </li>
              <li>
                Access all 8 classes online following completion of the course
                for the life of the course.
              </li>
              <li>
                Anatomy demos online prior to each class as a preparation for
                each class over Zoom.
              </li>
              <li>
                Enjoy supplemental videos as often and whenever desired along
                with other supplemental materials to enhance your learning.
              </li>
            </ul>
            <p>
              No experience necessary. Wear comfortable clothes you can move in
              and be able to get on and off the floor.
            </p>

            <h5 className="subTitle">What students say</h5>
            <div className="quoteGrid">
              <Quote
                who="Megan P"
                quote="I came for the Anatomy, I stayed for the Somatic Awareness and Energetic Attunement."
              />
              <Quote
                who="Nathan G"
                quote="After repeated athletic injuries over the years, Conscious Anatomy™ has helped me connect to and understand my body movements. I've been injury free ever since I started the courses."
              />
              <Quote
                who="Sandra B"
                quote="I always feel better after class. And I love that when I'm at the hospital for my Dad or a client, I understand the conversations I hear between the doctors and nurses."
              />
            </div>

            <p>
              Questions? Call <a href="tel:8605994533">(860) 599-4533</a> or
              email{" "}
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                bodymindspiritanatomy@gmail.com
              </a>
              .
            </p>
            <a
              href="https://www.bodymindspiritanatomy.com/"
              target="_blank"
              rel="noreferrer"
            >
              <Button>Class Details &amp; Registration ››</Button>
            </a>
          </article>

          {/* Post: Mini Chakra Series */}
          <article className="productCard">
            <h3 className="profileName">
              A Moment for Yourself: Mini Chakra Series
            </h3>
            <p className="profileCred">Sign-up information</p>
            <p>
              What will you get when you sign up for the Mini Chakra Series?
              The first day you&rsquo;ll receive Chakra Basics. A couple of
              days later in the week you will receive 20 Different Ways to Work
              with that Chakra.
            </p>
            <p>
              If you signed up as a member of the Conscious Anatomy™ site for
              free resources or a training, you should find yourself at the
              welcome page with directions for access. If that somehow
              doesn&rsquo;t happen you can always email me at{" "}
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                bodymindspiritanatomy@gmail.com
              </a>{" "}
              or call <a href="tel:8605994533">(860) 599-4533</a>. I&rsquo;ll
              get back to you asap if you don&rsquo;t catch me live.
            </p>
            <p>
              For Trainings, once you make your payment, you will have access
              to the Conscious Anatomy™ website which will give you access to
              each class as promised over the eight or nine week period as
              specified, and you will have continued access for an additional 2
              months after completion. At that point you can become a member of
              the site and have ongoing access. You always have access to the
              free resources on the site. Enjoy!
            </p>
            <div className="btnRow">
              <a
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                <Button>Sign Up for the Mini Chakra Series ››</Button>
              </a>
              <Link to="/aMomentForYourself">
                <Button variant="outline-primary">
                  A Moment for Yourself Archive ››
                </Button>
              </Link>
            </div>
          </article>

          <div className="contactBox">
            <h4 className="subTitle" style={{ marginTop: 0 }}>
              About the author
            </h4>
            <p style={{ marginBottom: 0 }}>
              Hi, I&rsquo;m Ann Watkins. I am passionate about bringing
              customized postural corrective pain reducing bodywork sessions
              and self-care movement classes and trainings to as many
              individuals as possible to improve the quality of life on the
              planet. More harmony in the world one group, one person at a
              time.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Blog;
